import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { MediaQuery } from '@grandvisionhq/common';
import LocationSearchListLayout from '../LocationSearchListLayout/LocationSearchListLayout.js';
import LocationSearch from './LocationSearch.js';

const LocationSearchContainer = (_param)=>{
    var { searchForm , loadingListItems , listItems , listTopContent , listInfoContent , mapContent , googleMapsId , showTabs , highlightPreferredStore  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "searchForm",
        "loadingListItems",
        "listItems",
        "listTopContent",
        "listInfoContent",
        "mapContent",
        "googleMapsId",
        "showTabs",
        "highlightPreferredStore"
    ]);
    const isMobile = MediaQuery.useIsPhone();
    const showPreferredStore = !listItems.length && !loadingListItems;
    return /*#__PURE__*/ React__default.createElement(LocationSearch, swcHelpers.extends({}, rest, {
        showTabs: showTabs,
        searchForm: searchForm,
        listTopContent: isMobile && listTopContent,
        scrollToHandlerId: "location-search-form",
        listContent: /*#__PURE__*/ React__default.createElement(LocationSearchListLayout, {
            googleMapsId: googleMapsId,
            showLinkToMap: !isMobile,
            topContent: !isMobile && listTopContent ? listTopContent : null,
            searchForm: searchForm,
            showTabs: showTabs,
            infoContent: listInfoContent !== null && listInfoContent !== void 0 ? listInfoContent : null,
            loadingListItems: loadingListItems,
            listItems: listItems,
            highlightPreferredStore: showPreferredStore && highlightPreferredStore
        }),
        mapContent: mapContent
    }));
};
var LocationSearchContainer$1 = LocationSearchContainer;

export { LocationSearchContainer$1 as default };
//# sourceMappingURL=LocationSearchContainer.js.map
